/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Go_To_Last_PageInputs */

const en_table_go_to_last_page = /** @type {(inputs: Table_Go_To_Last_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to last page`)
};

const pt_br2_table_go_to_last_page = /** @type {(inputs: Table_Go_To_Last_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para a última página`)
};

/**
* | output |
* | --- |
* | "Go to last page" |
*
* @param {Table_Go_To_Last_PageInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const table_go_to_last_page = /** @type {((inputs?: Table_Go_To_Last_PageInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Go_To_Last_PageInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_go_to_last_page(inputs)
	return pt_br2_table_go_to_last_page(inputs)
});